<template>
    <span class="not-found"
        ><h1>{{ title }}</h1>
        <h2>404</h2>
        <div class="image-cropper">
            <img
                class="not-found-robot"
                src="../assets/not-found-robot.png"
                alt="Sad Robot"
            />
        </div>
        <h3>
            Go back to your home page by clicking
            <router-link to="/">here</router-link>.
        </h3></span
    >
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const title = computed(() => {
    if ("type" in route.query && "name" in route.query) {
        return `Could not find the ${route.query.type} "${route.query.name}"`;
    }

    if ("type" in route.query && "id" in route.query) {
        return `Could not find the ${route.query.type} "${route.query.id}"`;
    }

    if ("type" in route.query) {
        return `Could not find the ${route.query.type} page`;
    }

    return "The page could not be found";
});
</script>
<style lang="css">
.not-found {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}

.image-cropper {
    width: 100%;
    max-width: 400px;
    max-height: 400px;
    margin: 0 auto;
    display: block;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
    aspect-ratio: 1/1;
}

.not-found-robot {
    width: 100%;
    max-width: 400px;
    max-height: 400px;
    margin: 0 auto;
    display: block;
    aspect-ratio: 1/1;
}
</style>
